<template>
  <div class="d-flex flex-column flex-root justify-content-center align-items-center min-vh-100 bg-light p-6">
    <div class="card shadow-sm p-8 text-center" style="max-width: 420px; width: 100%; border-radius: 12px; background: #fff;">
      <div v-if="loading" class="py-6">
        <div class="spinner spinner-primary spinner-lg mb-6" style="margin: 0 auto; display: inline-block;"></div>
        <h4 class="font-weight-bolder text-dark mb-2">Connecting to Info-Tech...</h4>
        <p class="text-muted font-size-sm">Please wait while we complete the authorization.</p>
      </div>

      <div v-else-if="success" class="py-6">
        <div class="mb-4 text-success" style="font-size: 50px; line-height: 1;">&#10004;</div>
        <h4 class="font-weight-bolder text-dark mb-2">Connected Successfully!</h4>
        <p class="text-muted font-size-sm mb-4">Info-Tech Accounting has been linked to your account.</p>
        <span class="badge badge-light-success font-weight-bold py-2 px-4 font-size-sm">This window will close automatically...</span>
      </div>

      <div v-else class="py-6">
        <div class="mb-4 text-danger" style="font-size: 50px; line-height: 1;">&#9888;</div>
        <h4 class="font-weight-bolder text-dark mb-2">Connection Failed</h4>
        <p class="text-danger font-size-sm mb-4">{{ errorMessage }}</p>
        <button class="btn btn-sm btn-secondary font-weight-bold" @click="closePopup">Close Window</button>
      </div>
    </div>
  </div>
</template>

<script>
import { GET } from "@/core/services/store/request.module";

export default {
  name: "InfoTechCallback",
  data() {
    return {
      loading: true,
      success: false,
      errorMessage: "",
    };
  },
  mounted() {
    this.handleCallback();
  },
  methods: {
    handleCallback() {
      const code = this.$route.query.code;
      const errorMsg = this.$route.query.errormessage || this.$route.query.errorstatus || this.$route.query.error_description || this.$route.query.error;

      if (errorMsg) {
        this.loading = false;
        this.errorMessage = errorMsg;
        return;
      }

      if (!code) {
        this.loading = false;
        this.errorMessage = "Authorization code was not provided by Info-Tech.";
        return;
      }

      const _this = this;
      _this.$store
        .dispatch(GET, { url: `infotech/callback?code=${code}` })
        .then(() => {
          _this.loading = false;
          _this.success = true;
          if (window.opener) {
            window.opener.postMessage({ type: "INFOTECH_CONNECTED" }, "*");
          }
          setTimeout(() => {
            window.close();
          }, 1200);
        })
        .catch((err) => {
          _this.loading = false;
          _this.errorMessage = (err && err.data && err.data.message) || err.message || "Failed to exchange authorization code.";
        });
    },
    closePopup() {
      window.close();
    },
  },
};
</script>
